export const maxNumberToShow = 3;

export const alertChatState = '아직 채팅방에 대화가 없습니다!';
